"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrictEqualityCheck = void 0;
class StrictEqualityCheck {
    check(a, b) {
        return a === b;
    }
}
exports.StrictEqualityCheck = StrictEqualityCheck;
//# sourceMappingURL=StrictEqualityCheck.js.map